import CryptoJS from 'crypto-js';
import Pagination from './../../../../../shared/components/pagination';
import Loader from './../../../../../shared/components/loader';
import CONSTANT from '../../../../../shared/constants/constant';
import Util from '../../../../../shared/util/util';
import TripServices from '../../../../services/firstAndLastmilemanagement.service'
import VueElementLoading from 'vue-element-loading';
import XLSX from 'xlsx';
import Treeselect from '@riophae/vue-treeselect';
import AddExtraChargesPDF from '../AddExtraChargesPDF'
import Printd from 'printd';
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export default {
    name: 'addextracharges',
    components: {
      VueElementLoading,
      AddExtraChargesPDF,
      CryptoJS,
      Pagination,
      Loader,
      Util,
      CONSTANT,
      TripServices,
      Treeselect
    },
  props: ['parentObj','childcharges'],
    data: function() {
        return{
          accordianTab:{1:false},
          isFTCshipment:0,
          awbErr: '',
          isEmpty: '',
          isSave: true,
          isDelete:false,
            showprint:false,
            pdfpayload:'',
            fromerr:'',
            toerr:'',
            allocationTypeList:[
              { id:'lastmile', label:'Delivery'},
              { id:'firstmile', label:'Pickup'},
              ],
            allocationtypesearch:'lastmile',
            shippingid:'',
            fromdate:'',
            todate:'',
            shippingsize:'',
            mathadi:'',
            portage:'',
            specialcharge:'',
            loadcharges:'',
            oda:'',
            fulltruckload:'',
            isLoading:false,
            data:'',
            shippingsizedpng:'',
            shipmentdoc:'',
            shipmentsizedocument:{},
            mathadidoc:'',
            mathadidocument:{},
            portgagesdoc:'',
            portgagedocument:{},
            specialchargedoc:'',
            specialchargedocument:{},
            loadingdoc:'',
            loadingdocument:{},
            odadoc:'',
            odadocument:{},
            fulltruckloaddoc:'',
            fulltruckloaddocument:{},
            deletePayload:{
            shipmentsize:'',
            mathadi:'',
            portgage:'',
            specialcharge:'',
            loading:'',
            oda:'',
            fulltruckload:'',
            expanded:false,
            // addChargesTabErr:'',
            // showchargestab:false,
            },
			addOtherChargesRemarks:'',

        }
    },
    mounted(){
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
	  this.userName = userdetail.email;
      this.hubid = userdetail.hubID[0];
      if(this.parentObj){
        this.expandAll()
        this.shippingid = this.parentObj.AWB;
        this.allocationtypesearch = 'lastmile';
        this.search();
      }
      if(this.childcharges){
          this.shippingid = this.childcharges.awb
          this.allocationtypesearch = this.childcharges.allocationtype
          this.shippingsize = this.childcharges.shipmentsized
          this.mathadi = this.childcharges.mathadi
          this.portage = this.childcharges.portgages
          this.specialcharge = this.childcharges.specialdelivery
          this.loadcharges = this.childcharges.loadingunloading
          this.oda = this.childcharges.oda
          this.fulltruckload = this.childcharges.fulltruckload
		  this.addOtherChargesRemarks = this.childcharges.remarks
          if (this.childcharges.shipmentsizeddoc.Location) {
            this.shipmentsizedocument = this.childcharges.shipmentsizeddoc;
            this.shipmentdoc = this.shipmentsizedocument.Location.substring(
              this.shipmentsizedocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.shipmentsizedocument = {};
            this.shipmentdoc = '';
          }
          if (this.childcharges.mathadidoc.Location) {
            this.mathadidocument = this.childcharges.mathadidoc;
            this.mathadidoc = this.mathadidocument.Location.substring(
              this.mathadidocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.mathadidocument = {};
            this.mathadidoc = '';
          }
          if (this.childcharges.portgagesdoc.Location) {
            this.portgagedocument = this.childcharges.portgagesdoc;
            this.portgagesdoc = this.portgagedocument.Location.substring(
              this.portgagedocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.portgagedocument = {};
            this.portgagesdoc = '';
          }
          if (this.childcharges.specialdeliverydoc.Location) {
            this.specialchargedocument = this.childcharges.specialdeliverydoc;
            this.specialchargedoc = this.specialchargedocument.Location.substring(
              this.specialchargedocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.specialchargedocument = {};
            this.specialchargedoc = '';
          }
          if (this.childcharges.loadingunloadingdoc.Location) {
            this.loadingdocument = this.childcharges.loadingunloadingdoc;
            this.loadingdoc = this.loadingdocument.Location.substring(
              this.loadingdocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.loadingdocument = {};
            this.loadingdoc = '';
          }
          if (this.childcharges.odadoc.Location) {
            this.odadocument = this.childcharges.odadoc
            this.odadoc = this.odadocument.Location.substring(
              this.odadocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.odadocument = {};
            this.odadoc = '';
          }
          if (this.childcharges.fulltruckloaddoc.Location) {
            this.fulltruckloaddocument = this.childcharges.fulltruckloaddoc;
            this.fulltruckloaddoc = this.fulltruckloaddocument.Location.substring(
              this.fulltruckloaddocument.Location.lastIndexOf(".") + 1
            );
          } else {
            this.fulltruckloaddocument = {};
            this.fulltruckloaddoc = '';
          }
          this.isSave = false
      }
    },
    methods: {
      async checkdate(){
        if(this.todate<this.fromdate && this.fromdate && this.todate){
          this.toerr="To date is Less than From date"
        }else{
          this.toerr=""
        }
      },
      // showFTCdetails(){
      // this.$emit("goBackToParent");
      // },
      async selectRemove(element){
        this.deletePayload.shippingid = this.shippingid
        this.isDelete=true
        if(element=='shipmentsize'){
        this.deletePayload[element]=1;
        this.shipmentsizedocument={}
        this.shipmentdoc=''
        this.$refs.files.form.ShipmentDocument.value='';
        }
        if(element=='mathadi'){
        this.deletePayload[element]=2
        this.mathadidocument = {};
        this.mathadidoc ='';
        this.$refs.files.form.MathadiDocument.value='';
        }
        if(element == 'portgage'){
        this.deletePayload[element]=3
        this.portgagedocument={}
        this.portgagesdoc=''
        this.$refs.files.form.PortgagesDocument.value='';
        }
        if(element == 'specialcharge'){
        this.deletePayload[element]=4
        this.specialchargedocument={}
        this.specialchargedoc=''
        this.$refs.files.form.SpecialChargeDocument.value='';
        }
        if(element == 'loading'){
        this.deletePayload[element]=5
        this.loadingdocument={}
        this.loadingdoc=''
        this.$refs.files.form.LoadingDocument.value='';
        }
        if(element == 'oda'){
        this.deletePayload[element]=6
        this.odadocument={}
        this.odadoc=''
        this.$refs.files.form.ODADocument.value='';
        }
        if(element == 'fulltruckload'){
        this.deletePayload[element]=7
        this.fulltruckloaddocument={}
        this.fulltruckloaddoc=''
        this.$refs.files.form.FullTruckLoadDocument.value='';
        }
        await this.deleteAwbData()
        this.deletePayload[element]='';
        },
      async deleteAwbData() {
        try {
          let payload = {
            fulltruckload: this.deletePayload.fulltruckload,
            loading: this.deletePayload.loading,
            mathadi: this.deletePayload.mathadi,
            oda: this.deletePayload.oda,
            portgage: this.deletePayload.portgage,
            shipmentsize: this.deletePayload.shipmentsize,
            shippingid: this.deletePayload.shippingid,
            specialcharge: this.deletePayload.specialcharge,
          }
          this.isLoading = true
          let result = await TripServices.RemoveAWBCharges(payload)
          console.log("result===============>",result)
          if (result.data.code == 200) {
          // let data = await this.search();
          this.isLoading = false
          }
           else {
            if(this.isEmpty){
              this.isLoading = false
            }
             else{
              this.$alert(result.data.message, "", "error");
              this.isLoading = false
            }
          }
        } catch (error) {
          this.isLoading = false
          console.log(error);
        }
      },
          async GetAwbChargesData(payload) {
            let data = await TripServices.GetAwbCharges(payload)
            return data
          },
        checkErr(){
            let err=1
            if(!this.fromdate){
                this.fromerr="Please select From date"
                err=0
              }else if(!this.todate){
                this.toerr="Please enter To date"
                err=0
            }else if((this.fromdate>this.todate)){
                this.toerr="To date is Less than From date"
                err=0
            }else{
                this.fromerr="",
                this.toerr=""
            }
            return err
        },

          async search() {
            try {
              this.addChargesTabErr = ''
              if(this.shippingid){
              this.awbErr=""
              this.isSave = false;
              this.isLoading=true
              this.todate = ''
              this.fromdate = ''
              let inputPayload = {
                "shippingid": this.shippingid,
                "allocationtype":this.allocationtypesearch,
                hubid:this.hubid
              }
              let result = await TripServices.GetAWBCharges(inputPayload)
              this.isLoading = false
              if (result.data.code == 200 || result.data.code == 204) {
                // this.showchargestab = true
                if (result.data.data.length == 0) {
                  this.isEmpty = true;
                } else {
                  this.isEmpty = false
                }
                let data = result.data.data[0]
                if(result.data.data.length == 0){
                  this.$alertify.success("AWB found with no extra charges")
                }
                if (data) {
                  this.shippingsize = data.shipmentsized
                  this.mathadi = data.mathadi
                  this.portage = data.portgages
                  this.specialcharge = data.specialdelivery
                  this.loadcharges = data.loadingunloading
                  this.oda = data.oda
                  this.fulltruckload = data.fulltruckload
				  this.addOtherChargesRemarks = data.remarks
                  if (data.shipmentsizeddoc.Location) {
                    this.shipmentsizedocument = data.shipmentsizeddoc;
                    this.shipmentdoc = this.shipmentsizedocument.Location.substring(
                      this.shipmentsizedocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.shipmentsizedocument = {};
                    this.shipmentdoc = '';
                  }
                  if (data.mathadidoc.Location) {
                    this.mathadidocument = data.mathadidoc;
                    this.mathadidoc = this.mathadidocument.Location.substring(
                      this.mathadidocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.mathadidocument = {};
                    this.mathadidoc = '';
                  }
                  if (data.portgagesdoc.Location) {
                    this.portgagedocument = data.portgagesdoc;
                    this.portgagesdoc = this.portgagedocument.Location.substring(
                      this.portgagedocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.portgagedocument = {};
                    this.portgagesdoc = '';
                  }
                  if (data.specialdeliverydoc.Location) {
                    this.specialchargedocument = data.specialdeliverydoc;
                    this.specialchargedoc = this.specialchargedocument.Location.substring(
                      this.specialchargedocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.specialchargedocument = {};
                    this.specialchargedoc = '';
                  }
                  if (data.loadingunloadingdoc.Location) {
                    this.loadingdocument = data.loadingunloadingdoc;
                    this.loadingdoc = this.loadingdocument.Location.substring(
                      this.loadingdocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.loadingdocument = {};
                    this.loadingdoc = '';
                  }
                  if (data.odadoc.Location) {
                    this.odadocument = data.odadoc
                    this.odadoc = this.odadocument.Location.substring(
                      this.odadocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.odadocument = {};
                    this.odadoc = '';
                  }
                  if (data.fulltruckloaddoc.Location) {
                    this.fulltruckloaddocument =
                      data.fulltruckloaddoc;
                    this.fulltruckloaddoc = this.fulltruckloaddocument.Location.substring(
                      this.fulltruckloaddocument.Location.lastIndexOf(".") + 1
                    );
                  } else {
                    this.fulltruckloaddocument = {};
                    this.fulltruckloaddoc = '';
                  }
                }
                else {
                  this.shippingsize = ''
                  this.mathadi = ''
                  this.portage = ''
                  this.specialcharge = ''
                  this.loadcharges = ''
                  this.oda = ''
                  this.fulltruckload = ''
                  this.shipmentdoc = ''
                  this.mathadidoc = ''
                  this.portgagesdoc = ''
                  this.specialchargedoc = ''
                  this.loadingdoc = ''
                  this.odadoc = ''
                  this.fulltruckloaddoc = ''
                }
                this.isFTCshipment = result.data.code == 204 ?1:0;
              } else {
                // this.addChargesTabErr = result.data.message
                // this.showchargestab = false
                this.$alert(result.data.message, " ", "error");
                if (this.parentObj)this.$emit("goBackToParent");
              }
            }else{
              this.awbErr="Please Enter Shipping ID"
            }
            } catch (error) {
              console.log(error.message)
              this.isLoading = false
            }
        },
        openImage(image) {
          let modal = document.getElementById('myModalImg' + image);
          var img = document.getElementById('imgid' + image);
          var modalImg = document.getElementById("img" + image);
          var captionText = document.getElementById("captionImg" + image);
          modal.style.display = "block";
          modalImg.src = image;

        },

        closemodal(id) {
          let modal = document.getElementById(id);
          modal.style.display = "none";
        },

        fileview(index){
            var link = document.createElement('a');
            link.href = index;
            link.setAttribute('target','_blank');
            window.open(index, '_blank');
            link.remove();
            return true;
          },
          uploadShipmentSizeDoc(event) {
            let filepath = "uploadshipmentdoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
            uploadMathadiDoc(event) {
            let filepath = "uploadmathadidoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
            uploadPortgageDoc(event) {
            let filepath = "uploadportgagedoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
            uploadSpecialChargeDoc(event) {
            let filepath = "uploadspecialchargedoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
            uploadLoadingDoc(event) {
            let filepath = "uploadloadingdoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
            uploadODADoc(event) {
            let filepath = "uploadodadoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
            uploadFullTruckLoadDoc(event) {
            let filepath = "uploadfulltruckloaddoc";
            this.isLoading = true
            this.uploadDoc(filepath,event);
            },
          async uploadDoc(filepath,event) {
            let uploadFile = event.target.files[0];
            if(uploadFile != undefined){
            if(uploadFile.size > 5242880){
              this.isLoading=false
              return this.$alert(`Please Upload Document Less Than 5MB.`,"Shipment  Sized Charge Document","error");
            }
            if (uploadFile.type == "image/jpeg" ||
            uploadFile.type == "image/jpg" ||uploadFile.type == "image/png" ||uploadFile.type == "application/pdf" ||
            uploadFile.type == "application/msword" ||uploadFile.type == "application/wps-office.docx" ||uploadFile.type == "application/wps-office.doc" ||
            uploadFile.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
            uploadFile.type == "")
            {
              let formData = new FormData();
              /*Add the form data we need to submit*/
              formData.append("file", uploadFile);
              formData.append(filepath, true);
              formData.append("shippingid", this.shippingid);
              formData.append("fileName", uploadFile.name);

              let result = await TripServices.uploadDocument(formData)
              if (result.data.code == 200) {
                let alertMessage = '';
                if (filepath == "uploadshipmentdoc") {
                  alertMessage = "Odd Size Shipments document"
                  this.shipmentsizedocument = {};
                  this.shipmentsizedocument = result.data.data;
                  this.shipmentdoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading=false
                }
                if (filepath == "uploadmathadidoc") {
                  alertMessage = "Mathadi/Varai/Union document"
                  this.mathadidocument = {};
                  this.mathadidocument = result.data.data;
                  this.mathadidoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading= false
                }
                if (filepath == "uploadportgagedoc") {
                  alertMessage = "Open Pick-up/Delivery document"
                  this.portgagedocument = {};
                  this.portgagedocument = result.data.data;
                  this.portgagesdoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading= false
                }
                if (filepath == "uploadspecialchargedoc") {
                  alertMessage = "Appointment/CSD/Mall Delivery document"
                  this.specialchargedocument = {};
                  this.specialchargedocument = result.data.data;
                  this.specialchargedoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading= false
                }
                if (filepath == "uploadloadingdoc") {
                  alertMessage = "Floor Pick-up/Delivery document"
                  this.loadingdocument = {};
                  this.loadingdocument = result.data.data;
                  this.loadingdoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading= false
                }
                if (filepath == "uploadodadoc") {
                  alertMessage = "ODA document"
                  this.odadocument = {};
                  this.odadocument = result.data.data;
                  this.odadoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading= false
                }
                if (filepath == "uploadfulltruckloaddoc") {
                  alertMessage = "Other document"
                  this.fulltruckloaddocument = {};
                  this.fulltruckloaddocument = result.data.data;
                  this.fulltruckloaddoc = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
                  this.isLoading= false
                }
                this.$alert(`${alertMessage} Upload successfully.`,"Add Extra Charges","success");
              }
              else {
                event.target.value = '';
                this.isLoading=false
                this.$alert("Document Upload Failed.","Add Extra Charges ","error");
              }
            }else {
              event.target.value = '';
              this.isLoading=false
              this.$alert("Please upload only Allowed file format","Add Extra Charges","error");
             return true;
            }
          }
          else{
            this.isLoading=false
          }
          },
          isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              return true;
            }
          },
        clear(){
          this.isFTCshipment = 0;
            this.shippingid = null
            this.shippingsize = '',
            this.mathadi = '',
            this.portage = '',
            this.specialcharge = '',
            this.loadcharges = '',
            this.oda = '',
            this.fulltruckload = ''
            this.shipmentdoc = ''
            this.mathadidoc = ''
            this.portgagesdoc = ''
            this.specialchargedoc =''
            this.loadingdoc = ''
            this.odadoc = ''
            this.fulltruckloaddoc =''
            this.shipmentsizedocument = {};
            this.mathadidocument = {};
            this.portgagedocument = {};
            this.specialchargedocument = {};
            this.loadingdocument = {};
            this.odadocument = {};
            this.fulltruckloaddocument = {};
        },
        clearCharges(){
            this.shippingsize = '',
            this.mathadi = '',
            this.portage = '',
            this.specialcharge = '',
            this.loadcharges = '',
            this.oda = '',
            this.fulltruckload = ''
            this.shipmentdoc = ''
            this.mathadidoc = ''
            this.portgagesdoc = ''
            this.specialchargedoc =''
            this.loadingdoc = ''
            this.odadoc = ''
            this.fulltruckloaddoc = ''
            this.todate = '',
            this.fromdate = ''
            this.shipmentsizedocument = {};
            this.mathadidocument = {};
            this.portgagedocument = {};
            this.specialchargedocument = {};
            this.loadingdocument = {};
            this.odadocument = {};
            this.fulltruckloaddocument = {};
			this.addOtherChargesRemarks='';
        },
      async saveCharges() {
        this.isSave= true
        this.isLoading = true
          let inputPayload = {
            "shippingid": this.shippingid,
            "allocationtype":this.allocationtypesearch,
            'ftcflag':this.isFTCshipment,
			'username':this.userName,
          }
          inputPayload.shipmentsized = this.shippingsize?this.shippingsize:0
          let sFilePath = {}
          if (this.shipmentsizedocument.Location) {
            sFilePath.Location = this.shipmentsizedocument.Location
          }
          inputPayload.shipmentsizeddoc = sFilePath
          inputPayload.mathadi = this.mathadi?this.mathadi:0
          let mFilePath = {}
          if (this.mathadidocument.Location) {
            mFilePath.Location = this.mathadidocument.Location
          }
          inputPayload.mathadidoc = mFilePath
          inputPayload.portgages = this.portage?this.portage:0
          let pFilePath = {}
          if (this.portgagedocument.Location) {
            pFilePath.Location = this.portgagedocument.Location
          }
          inputPayload.portgagesdoc = pFilePath
          inputPayload.specialdelivery = this.specialcharge?this.specialcharge:0
          let scFilePath = {}
          if (this.specialchargedocument.Location) {
            scFilePath.Location = this.specialchargedocument.Location
          }
          inputPayload.specialdeliverydoc = scFilePath
          inputPayload.loadingunloading = this.loadcharges?this.loadcharges:0
          let lFilePath = {}
          if (this.loadingdocument.Location) {
            lFilePath.Location = this.loadingdocument.Location
          }
          inputPayload.loadingunloadingdoc = lFilePath
          inputPayload.oda = this.oda?this.oda:0
          let oFilePath = {}
          if (this.odadocument.Location) {
            oFilePath.Location = this.odadocument.Location
          }
          inputPayload.odadoc = oFilePath
		  if(Math.ceil(this.fulltruckload)){
			if(this.addOtherChargesRemarks!='' && this.addOtherChargesRemarks!=null && this.addOtherChargesRemarks.trim()!=''){
				inputPayload.remarks =this.addOtherChargesRemarks.trim();
			}else{
				this.isLoading = false;
				this.isSave = false;
				this.$alertify.error("Please enter the remarks","","error");
				return false;
			}
		  }
          inputPayload.fulltruckload = this.fulltruckload?this.fulltruckload:0
          let fFilePath = {}
          if (this.fulltruckloaddocument.Location) {
            fFilePath.Location = this.fulltruckloaddocument.Location
          }
          inputPayload.fulltruckloaddoc = fFilePath
          if(this.shippingsize == '' && this.mathadi == '' && this.portage == '' && this.specialcharge == '' && this.loadcharges == '' && this.oda == '' && this.fulltruckload ==''){
            this.$alert("Please Enter Values", "Add Extra Charges", "error");
            this.isLoading = false
            this.isSave = false
          }
          else{
          let result = await TripServices.SaveAWBCharges(inputPayload)
          this.isLoading = false
          this.isSave = false
          if (result.data.code == 200) {
            this.$alert(result.data.message, "Add Extra Charges", "success");
            this.isSave = true;
            this.clearCharges()
            if (this.parentObj)this.$emit("goBackToParent");
          } else {
            this.$alert(result.data.message, "", "error");
          }
        }
      },
      showAddExtraCharges(){
        this.$emit("goBackToParent")
      },

      expandAll(){
        this.expanded = true;
        for (var key in this.accordianTab) {
            this.accordianTab[key] = true;
        }
      },
      collapseAll(){
        this.expanded = false;
        for (var key in this.accordianTab) {
          this.accordianTab[key] = false;
        }
      },
      toggleCheck(tabid){
        if(tabid == 1){
            if(this.expanded == false){
              this.expanded = false;
            }else{
              this.expanded = true;
            }
        }
        this.expanded = false;
        for (var key in this.accordianTab) {
          if(tabid != key){
            this.accordianTab[key] = false;
          }
        }
      },
	  isRemaksAdded(event){
		if(this.shippingid){
			this.isSave = false;
		}	
	  },
    }
  }



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/AddExtraCharges/CreateExtraCharges/ShowExtraCharges.component.js